<template>
  <div class="wrapper login bindphone">
    <div class="logo">在艺</div>
    <p
      style="text-align:center;color:#999;margin-top:0.2rem;margin-bottom:-0.18rem;"
    >请先通过手机号码安全验证后，继续使用</p>
    <div class="login-box">
      <div class="form-group">
        <PhoneCode-select v-model="form.phoneCode"></PhoneCode-select>
        <input type="tel" class="form-controls" placeholder="请输入手机号以便接收短信通知" v-model="form.phone">
      </div>
      <div class="form-group" v-if="isShowImageCode">
        <input
          type="text"
          class="form-controls"
          placeholder="请输入图片中的验证码"
          v-model="form.imageVerifyCode"
        >
        <image-code v-model="form.sessionId"></image-code>
      </div>
      <div class="form-group">
        <input
          type="tel"
          class="form-controls"
          placeholder="请输入短信验证码"
          maxlength="6"
          v-model="form.verifyCode"
        >
        <countdown-button ref="countdown" @click.native="onSendCode"></countdown-button>
      </div>
      <div class="form-group">
        <input type="button" class="btn btn-primary btn-login" value="确认" @click="onSubmit">
      </div>
      <p class="tips">
        <router-link
          :to="{path: 'login', query:{autologin: '0', appid: form.appId, code: form.code, loginType: form.loginType, redirect_uri: redirect_uri}}"
          replace
        >已绑定手机号，去登录</router-link>
      </p>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import PhoneCodeSelect from '@/components/PhoneCodeSelect'
import CountdownButton from '@/components/CountdownButton'
import ImageCode from '@/components/ImageCode'
import {
  sendCode,
  bindPhone,
  thirdRegister,
  phoneLogin,
  getCode
} from '@/api/login'
import { share } from '@/utils/share'

export default {
  name: 'BindPhone',
  components: { PhoneCodeSelect, CountdownButton, ImageCode },
  metaInfo: { title: '绑定手机号' },
  data() {
    return {
      form: {
        appId: '',
        code: '',
        loginType: null,
        phoneCode: '+86',
        phone: '',
        imageVerifyCode: '',
        sessionId: Math.random()
          .toString(36)
          .substr(2),
        verifyCode: ''
      },
      redirect_uri: '',
      isLogin: false,
      isShowImageCode: false // 显示图片验证码
    }
  },
  methods: {
    onSendCode() {
      if (this.form.appId && this.form.code && this.form.loginType) {
        // 发送第三方注册验证码
        // this.sendCode('THIRD_LOGIN_BIND_PHONE')
        this.sendCode('THIRD_LOGIN_BIND_PHONE_WITHOUT_CHECK_USER')
      } else {
        // 发送第三方绑定手机号验证码
        this.sendCode('THIRD_LOGIN_BIND_PHONE')
        // this.sendCode('THIRD_LOGIN_BIND_PHONE_WITHOUT_CHECK_USER')
      }
    },
    // 发送验证码
    sendCode(sendFuncType) {
      let param = {
        account: this.form.phoneCode + ' ' + this.form.phone,
        imageVerifyCode: this.form.imageVerifyCode,
        sendFuncType: sendFuncType,
        sessionId: this.form.sessionId
      }
      if (!this.form.phone) {
        this.$toast('请输入手机号以便接收短信通知')
        return false
      } else if (!param.imageVerifyCode) {
        this.$toast('请输入图片中的验证码')
        return false
      }
      // 验证码倒计时开始
      this.$refs.countdown.start()
      sendCode(param).catch(response => {
        this.$refs.countdown.stop()
        // 图形验证码错误，显示手动输入图形验证码
        if (response.code === 8000002 && !this.isShowImageCode) {
          this.isShowImageCode = true
          this.form.imageVerifyCode = ''
        }
        if (response.code === 30006 || response.code === 30012) {
          this.phoneIsRegister()
        }
      })
    },
    // 提交
    onSubmit() {
      if (this.isLogin) {
        // 手机号登录
        this.phoneLogin()
      } else if (this.form.appId && this.form.code && this.form.loginType) {
        // 第三方注册
        this.thirdRegister()
      } else {
        // 第三方绑定手机号
        this.bindPhone()
      }
    },
    // 第三方注册
    thirdRegister() {
      let param = {
        appId: this.form.appId,
        code: this.form.code,
        loginType: this.form.loginType,
        phone: this.form.phoneCode + ' ' + this.form.phone,
        verifyCode: this.form.verifyCode,
        utmSource: this.redirect_uri || location.href
      }
      if (!this.form.phone) {
        this.$toast('请输入手机号以便接收短信通知')
        return false
      } else if (!param.verifyCode) {
        this.$toast('请输入短信验证码')
        return false
      }
      thirdRegister(param)
        .then(response => {
          this.loginSuccess(response.data)
        })
        .catch(response => {
          if (response.code === 30006 || response.code === 30012) {
            this.phoneIsRegister()
          }
        })
    },
    // 绑定手机号
    bindPhone() {
      let param = {
        phone: this.form.phoneCode + ' ' + this.form.phone,
        verifyCode: this.form.verifyCode
      }
      if (!this.form.phone) {
        this.$toast('请输入手机号以便接收短信通知')
        return false
      } else if (!param.verifyCode) {
        this.$toast('请输入短信验证码')
        return false
      }
      bindPhone(param)
        .then(response => {
          if (this.redirect_uri) {
            location.href = this.redirect_uri
            setTimeout(() => {
              location.reload()
            }, 1000)
          } else {
            this.$router.push('/')
          }
        })
        .catch(response => {
          if (response.code === 30006 || response.code === 30012) {
            this.phoneIsRegister()
          }
        })
    },
    // 手机号已注册
    phoneIsRegister() {
      this.$messagebox({
        title: '',
        message:
          '检测到输入的手机号已经注册了在艺账户，请选择直接使用该手机号登录或者输入其他手机号',
        showCancelButton: true,
        closeOnClickModal: false,
        cancelButtonText: '更换手机',
        confirmButtonText: '当前手机号登录'
      }).then(action => {
        if (action === 'confirm') {
          this.isLogin = true
          // 自动发送手机登录验证码
          this.$refs.countdown.stop()
          this.sendCode('PHONE_VERIFY_CODE_LOGIN')
          // 去登录
          // this.$router.replace({
          //   path: 'login',
          //   query: {
          //     autologin: '0',
          //     phone: this.form.phone,
          //     appid: this.form.appId,
          //     code: this.form.code,
          //     loginType: this.form.loginType,
          //     redirect_uri: this.redirect_uri
          //   }
          // })
        }
      })
    },
    // 手机号登录
    phoneLogin() {
      let param = {
        appId: this.form.appId,
        code: this.form.code,
        loginType: this.form.loginType,
        phone: this.form.phoneCode + ' ' + this.form.phone,
        verifyCode: this.form.verifyCode,
        utmSource: this.redirect_uri || location.href
      }
      if (!this.form.phone) {
        this.$toast('请输入手机号')
        return false
      } else if (!param.verifyCode) {
        this.$toast('请输入短信验证码')
        return false
      }
      phoneLogin(param).then(response => {
        this.loginSuccess(response.data)
      })
    },
    // 登录成功
    loginSuccess(data) {
      Cookies.set('token', data.token, {
        domain: process.env.VUE_APP_COOKIES_DOMAIN,
        expires: 365
      })
      if (this.redirect_uri) {
        location.href = this.redirect_uri
        setTimeout(() => {
          location.reload()
        }, 1000)
      } else {
        this.$router.push('/')
      }
    },
    wechatBugfix(e) {
      window.scrollTo(0, 0)
    },
    getImageCode() {
      getCode({ sessionId: this.form.sessionId }).then(response => {
        let { verifyCode } = response.data
        if (verifyCode) {
          this.isShowImageCode = false
          this.form.imageVerifyCode = verifyCode
        } else {
          this.isShowImageCode = true
        }
      })
    }
  },
  created() {
    let query = this.$route.query
    this.redirect_uri = query.redirect_uri || ''
    this.form.appId = query.appid || ''
    this.form.code = query.code || ''
    this.form.loginType = query.state || ''

    // 分享语设置
    share({
      title: '在艺App',
      desc: '爱艺术的人都在这里',
      link: 'https://www.zai-art.com',
      imgUrl: 'https://img.zai-art.com/logo/512.png'
    })
  },
  beforeMount() {
    this.getImageCode()
  },
  mounted() {
    let aInput = document.querySelectorAll('input')
    aInput.forEach(element => {
      element.addEventListener('blur', this.wechatBugfix, false)
    })
  },
  beforeDestroy() {
    let aInput = document.querySelectorAll('input')
    aInput.forEach(element => {
      element.removeEventListener('blur', this.wechatBugfix, false)
    })
  }
}
</script>
<style src='@/assets/css/login.css'></style>
